module.exports = __webpack_public_path__ + "img/gb-sct.6caf73b8.svg";